import Drawer from '@material-ui/core/Drawer';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DrawerContainer = styled(Drawer)`
  & .MuiDrawer-paper {
    width: ${(props) => (props.width ? props.width : '0')};
    margin-top: ${(props) => (props.top ? props.top : '0')};
    z-index: ${(props) => (props.zIndex ? props.zIndex : '0')};
    /* box-shadow: none; Remova a sombra padrão do Drawer */
    /* overflow: visible; Permite que o conteúdo fique visível fora do Drawer */
  }
`;

const CustomDrawer = ({
  children,
  isActive,
  config = {
    position: 'right',
    width: '550px',
    top: '86px',
    zIndex: 0,
  },
}) => {
  return (
    <DrawerContainer
      width={config.width}
      top={config.top}
      open={isActive}
      anchor={config.position}
      ModalProps={{
        disableBackdropClick: true, // Desabilita o fechamento do modal ao clicar no fundo
        hideBackdrop: true, // Deixe isso como "false" para mostrar o fundo do modal
      }}
      style={{
        zIndex: config.zIndex,
        display: isActive ? 'flex' : 'none', // Altere o display com base na ativação
        inset: config.position === 'right' ? '0 0 0 auto' : '0 auto 0 0', // Posiciona o Drawer
      }}
    >
      {children}
    </DrawerContainer>
  );
};

CustomDrawer.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool.isRequired,
  config: PropTypes.shape({
    position: PropTypes.oneOf(['right', 'left', 'top', 'bottom']),
    width: PropTypes.string,
    top: PropTypes.string,
    zIndex: PropTypes.number,
  }),
};

export default CustomDrawer;
